import React from 'react';
import { BadgeProps } from './Badge.types';

export const Badge: React.FC<BadgeProps> = ({
  badgeVariation,
  badgeText,
  isInlineMerch = false,
  badgeIcon,
  customClass = '',
}) => {
  return (
    <>
      {badgeVariation === 'inline' && (
        <span
          data-component-name="a-ui-library-Badge"
          data-testid="ui-library-Badge"
          className={`${isInlineMerch ? 'm-badge-inline-merch' : 'm-badge-inline'} t-overline-normal ${customClass}`}
        >
          {badgeText}
        </span>
      )}
      {badgeVariation === 'overlay' && (
        <div
          data-component-name="a-ui-library-Badge"
          data-testid="ui-library-Badge"
          className={`m-badge-overlay-merch t-overline-normal ${customClass}`}
        >
          {badgeIcon && <span className={badgeIcon}></span>}
          {badgeText}
        </div>
      )}
    </>
  );
};
